(() => {
  const grid = () => document.querySelector('#ProductGridContainer');
  const sectionId = () => grid()?.dataset.sectionId;

  // simple lock to prevent double-fetch spam
  let busy = false;

  function setBusy(on) {
    const el = grid();
    if (!el) return;
    el.classList.toggle('go-loading', on);
  }

  function toggleParam(params, key, value) {
    // "All" clears the key completely
    if (!value) {
      params.delete(key);
      return;
    }

    // Shopify filter params allow repeated keys for multi-select
    const existing = params.getAll(key);

    if (existing.includes(value)) {
      // remove ONLY that value
      const next = existing.filter(v => v !== value);
      params.delete(key);
      next.forEach(v => params.append(key, v));
    } else {
      params.append(key, value);
    }
  }

  async function refreshWithParams(params) {
    const sid = sectionId();
    if (!sid) return;

    const url = new URL(window.location.href);
    url.search = params.toString();

    // IMPORTANT: only request this one section (fast)
    const fetchUrl = new URL(url.toString());
    fetchUrl.searchParams.set('section_id', sid);

    busy = true;
    setBusy(true);

    try {
      const res = await fetch(fetchUrl.toString(), {
        headers: { 'Accept': 'text/html' }
      });

      if (!res.ok) throw new Error('Section fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Replace the product grid section markup
      const newSectionRoot = doc.querySelector('#ProductGridContainer')?.closest('.shopify-section')
        || doc.querySelector('.shopify-section');

      const curSectionRoot = grid()?.closest('.shopify-section');
      if (newSectionRoot && curSectionRoot) {
        curSectionRoot.innerHTML = newSectionRoot.innerHTML;
      } else if (doc.querySelector('#ProductGridContainer') && grid()) {
        grid().innerHTML = doc.querySelector('#ProductGridContainer').innerHTML;
      }

      // Update URL (no page reload)
      window.history.pushState({}, '', url.toString());

      // Let theme listeners re-bind if they rely on events
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('facets:updated'));
    } catch (e) {
      // fallback: full navigation if anything goes wrong
      window.location.href = new URL(window.location.href).pathname + '?' + params.toString();
    } finally {
      setBusy(false);
      busy = false;
    }
  }

  // 1) Your custom filterbar buttons
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-go-filter]');
    if (!btn) return;
    if (busy) return;

    e.preventDefault();

    const key = btn.getAttribute('data-go-key');
    const value = btn.getAttribute('data-go-value') || '';

    const params = new URLSearchParams(window.location.search);

    // If user clicks an "All" option, clear that entire group
    if (!value) {
      params.delete(key);
    } else {
      toggleParam(params, key, value);
    }

    // OPTIONAL: reset pagination whenever filters change (better UX)
    params.delete('page');

    refreshWithParams(params);
  });

  // 2) Intercept theme “Clear all” and “remove” chips to prevent full reload
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a) return;

    // these are common selectors; even if Be Yours differs, this won’t hurt
    const isClear = a.textContent?.toLowerCase().includes('clear all');
    const isRemoveChip =
      a.className?.includes('active-facets') ||
      a.closest('.active-facets') ||
      a.closest('.facets-active') ||
      a.closest('.facets__active');

    if (!isClear && !isRemoveChip) return;
    if (busy) return;

    // If it’s not a URL change link, ignore
    const href = a.getAttribute('href');
    if (!href || !href.includes('?')) return;

    e.preventDefault();

    const url = new URL(href, window.location.origin);
    const params = new URLSearchParams(url.search);
    params.delete('page');

    refreshWithParams(params);
  });

  // handle back/forward
  window.addEventListener('popstate', () => {
    if (busy) return;
    const params = new URLSearchParams(window.location.search);
    refreshWithParams(params);
  });
})();
